import React from 'react'
import FocusableLink from '../../components/FocusableLink'
import PassportBadge from '../../components/PassportBadge'
import { secondsToHms } from '../../../../shared/helpers'

import type { EpisodeProps } from './types'

const Episode = <T extends object>(props: EpisodeProps<T>) => {
  const video = props.video
  const season = video.parent.season?.ordinal
    ? `S${video.parent.season?.ordinal} `
    : ''
  const episode = video.parent.ordinal ? `Ep${video.parent.ordinal} ` : ''
  const metadata = `${season}${episode}`
  const formattedDuration = secondsToHms(video.duration)
  const info = metadata
    ? `${metadata}| ${formattedDuration}`
    : formattedDuration

  const bgImage =
    video.images['asset-mezzanine-16x9'] ||
    video.images['asset-kids-mezzanine1-16x9'] ||
    ''
  const hasImage = !!bgImage

  return (
    <FocusableLink
      key={video.cid}
      className="season-content__episode"
      to={`/video-details/${encodeURIComponent(video.url)}`}
      onFocus={props.onFocus}
      extraProps={props.extraProps}
    >
      {video.flags.is_mvod && (
        <PassportBadge
          sizePx={110}
          className="season-content__episode__passport-badge"
        />
      )}
      <div className="season-content__episode__image-container">
        {hasImage ? (
          <img
            className="season-content__episode__background-image"
            src={`${bgImage}?resize=350x205&format=webp`}
          />
        ) : (
          <p className="season-content__episode__optional-background">
            {video.title}
          </p>
        )}
      </div>
      <div className="season-content__episode__data">
        <h3 className="season-content__episode__title">{video.title}</h3>
        <p className="season-content__episode__info">{info}</p>
        <p className="season-content__episode__description">
          {video.description_short}
        </p>
      </div>
    </FocusableLink>
  )
}

export default Episode
